module.exports = {
	"v": "5.0.5",
	"fr": 30,
	"ip": 0,
	"op": 75,
	"w": 760,
	"h": 868,
	"nm": "unify-animation",
	"ddd": 0,
	"assets": [
		{
			"id": "image_0",
			"w": 760,
			"h": 868,
			"u": "pages/media-publishing/animations/unify/images/",
			"p": "img_0.png"
		}
	],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 4,
			"nm": "bar Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						380,
						433.674,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						380,
						433.674,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											80.612,
											0.378
										],
										[
											53.362,
											-52.984
										],
										[
											0.379,
											-80.99
										],
										[
											-52.984,
											-53.363
										],
										[
											-80.99,
											-0.378
										],
										[
											-53.362,
											52.985
										],
										[
											-0.379,
											80.99
										],
										[
											52.984,
											53.363
										]
									],
									"o": [
										[
											-80.99,
											-0.378
										],
										[
											-53.363,
											52.984
										],
										[
											-0.378,
											80.99
										],
										[
											52.984,
											53.362
										],
										[
											80.99,
											0.379
										],
										[
											53.364,
											-52.983
										],
										[
											0.378,
											-80.99
										],
										[
											-52.984,
											-53.362
										]
									],
									"v": [
										[
											1.324,
											-293.495
										],
										[
											-206.449,
											-208.342
										],
										[
											-293.495,
											-1.325
										],
										[
											-208.342,
											206.449
										],
										[
											-1.325,
											293.494
										],
										[
											206.448,
											208.34
										],
										[
											293.495,
											1.324
										],
										[
											208.341,
											-206.45
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.277999997606,
									0.556999954523,
									0.902000038297,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 4,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									378.031,
									433.503
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 2,
					"cix": 2,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.667
									],
									"y": [
										0.939
									]
								},
								"o": {
									"x": [
										0.333
									],
									"y": [
										0
									]
								},
								"n": [
									"0p667_0p939_0p333_0"
								],
								"t": 15,
								"s": [
									100
								],
								"e": [
									0
								]
							},
							{
								"i": {
									"x": [
										0.667
									],
									"y": [
										1
									]
								},
								"o": {
									"x": [
										0.333
									],
									"y": [
										-0.208
									]
								},
								"n": [
									"0p667_1_0p333_-0p208"
								],
								"t": 74,
								"s": [
									0
								],
								"e": [
									0
								]
							},
							{
								"t": 76
							}
						],
						"ix": 1
					},
					"e": {
						"a": 0,
						"k": 100,
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": 0,
						"ix": 3
					},
					"m": 1,
					"ix": 2,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				}
			],
			"ip": 0,
			"op": 75,
			"st": 15,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 4,
			"nm": "Social Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"n": [
								"0p833_0p833_0p167_0p167"
							],
							"t": 15,
							"s": [
								20
							],
							"e": [
								100
							]
						},
						{
							"t": 19
						}
					],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						380,
						433.674,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						380,
						433.674,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											1.296,
											0
										],
										[
											0,
											-3.034
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-1.471,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											-2.706,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-1.027
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.324,
											-0.044
										]
									],
									"v": [
										[
											2.443,
											-9.969
										],
										[
											-2.117,
											-5.283
										],
										[
											-2.117,
											-2.67
										],
										[
											-5.177,
											-2.67
										],
										[
											-5.177,
											0.875
										],
										[
											-2.117,
											0.875
										],
										[
											-2.117,
											9.969
										],
										[
											1.544,
											9.969
										],
										[
											1.544,
											0.875
										],
										[
											4.596,
											0.875
										],
										[
											5.052,
											-2.67
										],
										[
											1.544,
											-2.67
										],
										[
											1.544,
											-4.932
										],
										[
											3.299,
											-6.658
										],
										[
											5.176,
											-6.658
										],
										[
											5.176,
											-9.828
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-401.22,
													834.008
												],
												[
													358.78,
													834.008
												],
												[
													358.78,
													-33.341
												],
												[
													-401.22,
													-33.341
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-401.22,
													-33.341
												],
												[
													358.78,
													-33.341
												],
												[
													358.78,
													834.008
												],
												[
													-401.22,
													834.008
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									401.22,
									33.341
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 4,
					"cix": 2,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											4.043,
											-2.688
										],
										[
											2.271,
											-0.299
										],
										[
											0.696,
											0
										],
										[
											0,
											8.266
										],
										[
											-8.266,
											0
										],
										[
											-0.677,
											-0.12
										],
										[
											-1.832,
											-1.255
										],
										[
											0,
											-5.199
										]
									],
									"o": [
										[
											-1.832,
											1.235
										],
										[
											-0.678,
											0.119
										],
										[
											-8.266,
											0
										],
										[
											0,
											-8.265
										],
										[
											0.696,
											0
										],
										[
											2.291,
											0.299
										],
										[
											4.043,
											2.669
										],
										[
											0,
											5.198
										]
									],
									"v": [
										[
											8.296,
											12.478
										],
										[
											2.082,
											14.829
										],
										[
											0.011,
											14.988
										],
										[
											-14.987,
											0.01
										],
										[
											0.011,
											-14.987
										],
										[
											2.062,
											-14.828
										],
										[
											8.296,
											-12.458
										],
										[
											14.988,
											0.01
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											8.425,
											2.151
										],
										[
											1.673,
											0
										],
										[
											0.458,
											-0.04
										],
										[
											0,
											-10.317
										],
										[
											-10.157,
											-0.697
										],
										[
											-0.458,
											0
										],
										[
											-1.553,
											0.398
										],
										[
											0,
											9.102
										]
									],
									"o": [
										[
											-1.553,
											-0.399
										],
										[
											-0.479,
											0
										],
										[
											-10.137,
											0.697
										],
										[
											0,
											10.317
										],
										[
											0.458,
											0.04
										],
										[
											1.673,
											0
										],
										[
											8.425,
											-2.152
										],
										[
											0,
											-9.122
										]
									],
									"v": [
										[
											4.87,
											-18.911
										],
										[
											0.011,
											-19.529
										],
										[
											-1.384,
											-19.469
										],
										[
											-19.528,
											0.01
										],
										[
											-1.364,
											19.469
										],
										[
											0.011,
											19.529
										],
										[
											4.87,
											18.912
										],
										[
											19.529,
											0.01
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-401.211,
													834.018
												],
												[
													358.789,
													834.018
												],
												[
													358.789,
													-33.331
												],
												[
													-401.211,
													-33.331
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-401.211,
													-33.331
												],
												[
													358.789,
													-33.331
												],
												[
													358.789,
													834.018
												],
												[
													-401.211,
													834.018
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									401.211,
									33.331
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 2",
					"np": 6,
					"cix": 2,
					"ix": 2,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											8.266,
											0
										],
										[
											0.677,
											0.119
										],
										[
											1.833,
											1.215
										],
										[
											0,
											5.199
										],
										[
											-4.023,
											2.689
										],
										[
											-2.271,
											0.299
										],
										[
											-0.697,
											0
										],
										[
											0,
											-8.265
										]
									],
									"o": [
										[
											-0.717,
											0
										],
										[
											-2.271,
											-0.299
										],
										[
											-4.023,
											-2.688
										],
										[
											0,
											-5.198
										],
										[
											1.833,
											-1.235
										],
										[
											0.677,
											-0.12
										],
										[
											8.266,
											0
										],
										[
											0,
											8.266
										]
									],
									"v": [
										[
											-0.01,
											14.988
										],
										[
											-2.101,
											14.829
										],
										[
											-8.296,
											12.498
										],
										[
											-14.988,
											0.01
										],
										[
											-8.296,
											-12.478
										],
										[
											-2.081,
											-14.828
										],
										[
											-0.01,
											-14.987
										],
										[
											14.988,
											0.01
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											10.157,
											0.717
										],
										[
											0.458,
											0
										],
										[
											1.554,
											-0.398
										],
										[
											0,
											-9.122
										],
										[
											-8.425,
											-2.152
										],
										[
											-1.673,
											0
										],
										[
											-0.438,
											0.02
										],
										[
											0,
											10.317
										]
									],
									"o": [
										[
											-0.459,
											-0.02
										],
										[
											-1.673,
											0
										],
										[
											-8.425,
											2.151
										],
										[
											0,
											9.103
										],
										[
											1.554,
											0.398
										],
										[
											0.458,
											0
										],
										[
											10.158,
											-0.697
										],
										[
											0,
											-10.336
										]
									],
									"v": [
										[
											1.365,
											-19.489
										],
										[
											-0.01,
											-19.529
										],
										[
											-4.87,
											-18.911
										],
										[
											-19.529,
											0.01
										],
										[
											-4.87,
											18.912
										],
										[
											-0.01,
											19.529
										],
										[
											1.344,
											19.489
										],
										[
											19.529,
											0.01
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-355.442,
													834.018
												],
												[
													404.558,
													834.018
												],
												[
													404.558,
													-33.331
												],
												[
													-355.442,
													-33.331
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-355.442,
													-33.331
												],
												[
													404.558,
													-33.331
												],
												[
													404.558,
													834.018
												],
												[
													-355.442,
													834.018
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									355.442,
									33.331
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 3",
					"np": 6,
					"cix": 2,
					"ix": 3,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											1.039,
											0
										],
										[
											0,
											-1.992
										],
										[
											-0.062,
											-0.264
										],
										[
											1.78,
											2.183
										],
										[
											0,
											-0.662
										],
										[
											-0.967,
											-0.647
										],
										[
											0.487,
											0.271
										],
										[
											0,
											0
										],
										[
											-1.65,
											-0.332
										],
										[
											0.33,
											0
										],
										[
											0.221,
											0.043
										],
										[
											-1.579,
											-0.029
										],
										[
											1.69,
											0
										],
										[
											0.282,
											0.031
										],
										[
											-2.038,
											0
										],
										[
											0,
											4.769
										],
										[
											0,
											0
										],
										[
											-0.483,
											0.723
										],
										[
											0.73,
											-0.087
										],
										[
											-0.271,
											0.841
										],
										[
											0.822,
											-0.162
										]
									],
									"o": [
										[
											-1.993,
											0
										],
										[
											0,
											0.282
										],
										[
											-2.999,
											-0.151
										],
										[
											-0.311,
											0.532
										],
										[
											0,
											1.252
										],
										[
											-0.591,
											-0.02
										],
										[
											0,
											0
										],
										[
											0,
											1.747
										],
										[
											-0.302,
											0.081
										],
										[
											-0.233,
											0
										],
										[
											0.459,
											1.434
										],
										[
											-1.234,
											0.967
										],
										[
											-0.292,
											0
										],
										[
											1.597,
											1.025
										],
										[
											6.638,
											0
										],
										[
											0,
											0
										],
										[
											0.709,
											-0.506
										],
										[
											-0.648,
											0.287
										],
										[
											0.745,
											-0.446
										],
										[
											-0.699,
											0.413
										],
										[
											-0.658,
											-0.703
										]
									],
									"v": [
										[
											3.383,
											-7.145
										],
										[
											-0.225,
											-3.536
										],
										[
											-0.133,
											-2.714
										],
										[
											-7.57,
											-6.484
										],
										[
											-8.057,
											-4.67
										],
										[
											-6.454,
											-1.667
										],
										[
											-8.087,
											-2.121
										],
										[
											-8.087,
											-2.075
										],
										[
											-5.194,
											1.463
										],
										[
											-6.145,
											1.589
										],
										[
											-6.824,
											1.523
										],
										[
											-3.454,
											4.029
										],
										[
											-7.935,
											5.571
										],
										[
											-8.796,
											5.522
										],
										[
											-3.264,
											7.145
										],
										[
											7.003,
											-3.122
										],
										[
											6.99,
											-3.589
										],
										[
											8.796,
											-5.453
										],
										[
											6.723,
											-4.885
										],
										[
											8.309,
											-6.88
										],
										[
											6.016,
											-6.004
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											4.744,
											-0.657
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.729,
											-0.037
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											-0.127,
											3.19
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.702,
											0.165
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											5.145,
											-2.833
										],
										[
											-1.954,
											5.206
										],
										[
											1.788,
											2.273
										],
										[
											-0.898,
											2.224
										],
										[
											2.896,
											1.203
										],
										[
											-1.31,
											0.355
										],
										[
											-0.029,
											0.399
										],
										[
											-2.376,
											-1.17
										],
										[
											-0.225,
											-0.865
										],
										[
											2.228,
											-0.742
										],
										[
											1.832,
											-2.439
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 2,
							"ty": "sh",
							"ix": 3,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-0.797,
											0
										],
										[
											-0.117,
											-0.024
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0.123,
											0
										],
										[
											0,
											0
										],
										[
											0.214,
											-0.728
										]
									],
									"v": [
										[
											3.383,
											-5.293
										],
										[
											3.741,
											-5.257
										],
										[
											1.697,
											-4.032
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 3",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-355.523,
													834.008
												],
												[
													404.477,
													834.008
												],
												[
													404.477,
													-33.341
												],
												[
													-355.523,
													-33.341
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-355.523,
													-33.341
												],
												[
													404.477,
													-33.341
												],
												[
													404.477,
													834.008
												],
												[
													-355.523,
													834.008
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 5,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									355.523,
									33.341
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 4",
					"np": 7,
					"cix": 2,
					"ix": 4,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											1.374,
											2.012
										],
										[
											1.672,
											0
										],
										[
											0.458,
											-0.04
										],
										[
											-0.975,
											-1.673
										],
										[
											-1.832,
											-1.255
										]
									],
									"o": [
										[
											-1.554,
											-0.398
										],
										[
											-0.479,
											0
										],
										[
											1.315,
											1.414
										],
										[
											2.291,
											0.299
										],
										[
											-0.897,
											-2.29
										]
									],
									"v": [
										[
											27.755,
											-19.041
										],
										[
											22.896,
											-19.659
										],
										[
											21.5,
											-19.599
										],
										[
											24.945,
											-14.958
										],
										[
											31.181,
											-12.588
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0.458,
											0
										],
										[
											1.553,
											-0.398
										],
										[
											0.896,
											-2.27
										],
										[
											-2.27,
											0.299
										],
										[
											-1.295,
											1.434
										]
									],
									"o": [
										[
											-1.673,
											0
										],
										[
											-1.374,
											1.992
										],
										[
											1.832,
											-1.235
										],
										[
											0.976,
											-1.673
										],
										[
											-0.458,
											-0.02
										]
									],
									"v": [
										[
											-22.895,
											-19.659
										],
										[
											-27.754,
											-19.041
										],
										[
											-31.181,
											-12.608
										],
										[
											-24.966,
											-14.958
										],
										[
											-21.521,
											-19.619
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 2,
							"ty": "sh",
							"ix": 3,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0.996,
											1.673
										],
										[
											1.832,
											1.215
										],
										[
											-1.354,
											-1.992
										],
										[
											-1.673,
											0
										],
										[
											-0.438,
											0.02
										]
									],
									"o": [
										[
											-2.27,
											-0.299
										],
										[
											0.916,
											2.271
										],
										[
											1.553,
											0.398
										],
										[
											0.458,
											0
										],
										[
											-1.295,
											-1.434
										]
									],
									"v": [
										[
											-24.987,
											14.699
										],
										[
											-31.181,
											12.368
										],
										[
											-27.754,
											18.782
										],
										[
											-22.895,
											19.399
										],
										[
											-21.54,
											19.359
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 3",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 3,
							"ty": "sh",
							"ix": 4,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											2.27,
											-0.299
										],
										[
											1.314,
											-1.414
										],
										[
											-0.458,
											0
										],
										[
											-1.554,
											0.398
										],
										[
											-0.897,
											2.291
										]
									],
									"o": [
										[
											-0.977,
											1.673
										],
										[
											0.458,
											0.04
										],
										[
											1.672,
											0
										],
										[
											1.374,
											-1.992
										],
										[
											-1.832,
											1.235
										]
									],
									"v": [
										[
											24.966,
											14.699
										],
										[
											21.521,
											19.339
										],
										[
											22.896,
											19.399
										],
										[
											27.755,
											18.782
										],
										[
											31.181,
											12.348
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 4",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 4,
							"ty": "sh",
							"ix": 5,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0.178,
											0
										],
										[
											0.498,
											0.04
										],
										[
											1.314,
											0.339
										],
										[
											6.453,
											0
										],
										[
											4.82,
											3.565
										],
										[
											1.395,
											-0.099
										],
										[
											0,
											0
										],
										[
											0.537,
											0
										],
										[
											0.179,
											0.02
										],
										[
											-9.102,
											0
										],
										[
											-6.035,
											5.916
										]
									],
									"o": [
										[
											-0.578,
											0
										],
										[
											-1.374,
											-0.099
										],
										[
											-4.82,
											3.565
										],
										[
											-6.433,
											0
										],
										[
											-1.295,
											0.339
										],
										[
											0,
											0
										],
										[
											-0.518,
											0.02
										],
										[
											-0.18,
											0
										],
										[
											6.035,
											5.916
										],
										[
											9.122,
											0
										],
										[
											-0.179,
											0.02
										]
									],
									"v": [
										[
											22.896,
											23.94
										],
										[
											21.221,
											23.88
										],
										[
											17.178,
											23.243
										],
										[
											-0.01,
											28.919
										],
										[
											-17.178,
											23.263
										],
										[
											-21.223,
											23.9
										],
										[
											-21.322,
											23.9
										],
										[
											-22.895,
											23.94
										],
										[
											-23.413,
											23.92
										],
										[
											-0.01,
											33.46
										],
										[
											23.413,
											23.92
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 5",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 5,
							"ty": "sh",
							"ix": 6,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											9.122,
											0
										],
										[
											6.015,
											-5.895
										],
										[
											-0.18,
											0
										],
										[
											-0.518,
											-0.04
										],
										[
											0,
											0
										],
										[
											-1.295,
											-0.319
										],
										[
											-6.433,
											0
										],
										[
											-4.8,
											-3.566
										],
										[
											-1.353,
											0.1
										],
										[
											-0.598,
											0
										],
										[
											-0.179,
											-0.02
										]
									],
									"o": [
										[
											-9.122,
											0
										],
										[
											0.179,
											-0.02
										],
										[
											0.518,
											0
										],
										[
											0,
											0
										],
										[
											1.375,
											0.1
										],
										[
											4.8,
											-3.546
										],
										[
											6.434,
											0
										],
										[
											1.275,
											-0.319
										],
										[
											0.578,
											-0.04
										],
										[
											0.178,
											0
										],
										[
											-6.035,
											-5.895
										]
									],
									"v": [
										[
											-0.01,
											-33.7
										],
										[
											-23.413,
											-24.18
										],
										[
											-22.895,
											-24.2
										],
										[
											-21.322,
											-24.14
										],
										[
											-21.202,
											-24.14
										],
										[
											-17.178,
											-23.522
										],
										[
											-0.01,
											-29.159
										],
										[
											17.178,
											-23.502
										],
										[
											21.121,
											-24.12
										],
										[
											22.896,
											-24.2
										],
										[
											23.413,
											-24.18
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 6",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-378.327,
													833.889
												],
												[
													381.673,
													833.889
												],
												[
													381.673,
													-33.46
												],
												[
													-378.327,
													-33.46
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-378.327,
													-33.46
												],
												[
													381.673,
													-33.46
												],
												[
													381.673,
													833.889
												],
												[
													-378.327,
													833.889
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 8,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									378.327,
									33.46
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 5",
					"np": 10,
					"cix": 2,
					"ix": 5,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 75,
			"st": 15,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 4,
			"nm": "Global Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"n": [
								"0p833_0p833_0p167_0p167"
							],
							"t": 29,
							"s": [
								20
							],
							"e": [
								100
							]
						},
						{
							"t": 33
						}
					],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						380,
						433.674,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						380,
						433.674,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.737,
											0
										],
										[
											-0.717,
											-0.08
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0.717,
											-0.08
										],
										[
											0.736,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-2.211,
											30.533
										],
										[
											-2.211,
											-30.433
										],
										[
											0,
											-30.533
										],
										[
											2.21,
											-30.433
										],
										[
											2.21,
											30.533
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.53,
													628.949
												],
												[
													33.47,
													628.949
												],
												[
													33.47,
													-238.4
												],
												[
													-726.53,
													-238.4
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.53,
													-238.4
												],
												[
													33.47,
													-238.4
												],
												[
													33.47,
													628.949
												],
												[
													-726.53,
													628.949
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									726.53,
									238.4
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 4,
					"cix": 2,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-31.91,
											-2.21
										],
										[
											31.911,
											-2.21
										],
										[
											31.911,
											2.21
										],
										[
											-31.91,
											2.21
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.522,
													630.333
												],
												[
													33.478,
													630.333
												],
												[
													33.478,
													-237.015
												],
												[
													-726.522,
													-237.015
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.522,
													-237.015
												],
												[
													33.478,
													-237.015
												],
												[
													33.478,
													630.333
												],
												[
													-726.522,
													630.333
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									726.522,
									237.015
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 2",
					"np": 4,
					"cix": 2,
					"ix": 2,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-1.394,
											-0.796
										],
										[
											-2.37,
											-0.817
										],
										[
											-1.534,
											-0.379
										],
										[
											-3.924,
											-0.14
										],
										[
											-0.737,
											0
										],
										[
											-0.717,
											0.02
										],
										[
											-3.406,
											0.797
										],
										[
											-1.395,
											0.478
										],
										[
											-1.952,
											1.135
										],
										[
											-1.115,
											0.916
										],
										[
											1.015,
											1.115
										],
										[
											1.434,
											-0.776
										],
										[
											1.813,
											-0.637
										],
										[
											1.535,
											-0.359
										],
										[
											3.446,
											-0.12
										],
										[
											0.736,
											0
										],
										[
											0.737,
											0.039
										],
										[
											3.027,
											0.717
										],
										[
											1.375,
											0.478
										],
										[
											1.454,
											0.797
										],
										[
											1.095,
											0.936
										],
										[
											0.856,
											-1.255
										]
									],
									"o": [
										[
											1.912,
											1.135
										],
										[
											1.395,
											0.478
										],
										[
											3.405,
											0.797
										],
										[
											0.717,
											0.02
										],
										[
											0.736,
											0
										],
										[
											3.924,
											-0.14
										],
										[
											1.533,
											-0.379
										],
										[
											2.389,
											-0.837
										],
										[
											1.374,
											-0.796
										],
										[
											-0.856,
											-1.255
										],
										[
											-1.076,
											0.916
										],
										[
											-1.474,
											0.817
										],
										[
											-1.374,
											0.478
										],
										[
											-3.027,
											0.717
										],
										[
											-0.736,
											0.039
										],
										[
											-0.737,
											0
										],
										[
											-3.446,
											-0.12
										],
										[
											-1.554,
											-0.359
										],
										[
											-1.773,
											-0.617
										],
										[
											-1.474,
											-0.777
										],
										[
											-1.015,
											1.115
										],
										[
											1.115,
											0.936
										]
									],
									"v": [
										[
											-24.119,
											0.259
										],
										[
											-17.667,
											3.187
										],
										[
											-13.244,
											4.462
										],
										[
											-2.21,
											5.896
										],
										[
											0.001,
											5.935
										],
										[
											2.211,
											5.896
										],
										[
											13.246,
											4.462
										],
										[
											17.648,
											3.187
										],
										[
											24.16,
											0.239
										],
										[
											27.904,
											-2.35
										],
										[
											25.096,
											-5.935
										],
										[
											21.312,
											-3.386
										],
										[
											16.372,
											-1.215
										],
										[
											11.99,
											0.04
										],
										[
											2.211,
											1.335
										],
										[
											0.001,
											1.394
										],
										[
											-2.21,
											1.335
										],
										[
											-11.99,
											0.04
										],
										[
											-16.391,
											-1.215
										],
										[
											-21.232,
											-3.346
										],
										[
											-25.095,
											-5.915
										],
										[
											-27.904,
											-2.35
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.53,
													646.815
												],
												[
													33.47,
													646.815
												],
												[
													33.47,
													-220.534
												],
												[
													-726.53,
													-220.534
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.53,
													-220.534
												],
												[
													33.47,
													-220.534
												],
												[
													33.47,
													646.815
												],
												[
													-726.53,
													646.815
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									726.53,
									220.534
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 3",
					"np": 4,
					"cix": 2,
					"ix": 3,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-0.996,
											-1.135
										],
										[
											-1.414,
											0.758
										],
										[
											-1.792,
											0.638
										],
										[
											-1.554,
											0.359
										],
										[
											-3.446,
											0.12
										],
										[
											-0.737,
											0
										],
										[
											-0.736,
											-0.04
										],
										[
											-3.027,
											-0.716
										],
										[
											-1.374,
											-0.477
										],
										[
											-1.455,
											-0.797
										],
										[
											-1.096,
											-0.936
										],
										[
											-0.856,
											1.254
										],
										[
											1.393,
											0.816
										],
										[
											2.37,
											0.817
										],
										[
											1.533,
											0.379
										],
										[
											3.924,
											0.14
										],
										[
											0.736,
											0
										],
										[
											0.717,
											-0.02
										],
										[
											3.405,
											-0.796
										],
										[
											1.395,
											-0.478
										],
										[
											1.932,
											-1.135
										],
										[
											1.076,
											-0.896
										]
									],
									"o": [
										[
											1.075,
											-0.896
										],
										[
											1.473,
											-0.816
										],
										[
											1.375,
											-0.477
										],
										[
											3.027,
											-0.716
										],
										[
											0.737,
											-0.04
										],
										[
											0.736,
											0
										],
										[
											3.446,
											0.12
										],
										[
											1.535,
											0.359
										],
										[
											1.774,
											0.618
										],
										[
											1.473,
											0.797
										],
										[
											1.015,
											-1.136
										],
										[
											-1.115,
											-0.936
										],
										[
											-1.933,
											-1.096
										],
										[
											-1.395,
											-0.478
										],
										[
											-3.406,
											-0.796
										],
										[
											-0.717,
											-0.02
										],
										[
											-0.737,
											0
										],
										[
											-3.924,
											0.14
										],
										[
											-1.534,
											0.379
										],
										[
											-2.39,
											0.837
										],
										[
											-1.334,
											0.777
										],
										[
											0.856,
											1.255
										]
									],
									"v": [
										[
											-25.075,
											5.875
										],
										[
											-21.35,
											3.385
										],
										[
											-16.431,
											1.215
										],
										[
											-12.029,
											-0.04
										],
										[
											-2.25,
											-1.335
										],
										[
											-0.039,
											-1.395
										],
										[
											2.171,
											-1.335
										],
										[
											11.95,
											-0.04
										],
										[
											16.332,
											1.215
										],
										[
											21.193,
											3.346
										],
										[
											25.057,
											5.936
										],
										[
											27.864,
											2.35
										],
										[
											24.101,
											-0.279
										],
										[
											17.608,
											-3.188
										],
										[
											13.206,
											-4.462
										],
										[
											2.171,
											-5.896
										],
										[
											-0.039,
											-5.936
										],
										[
											-2.25,
											-5.896
										],
										[
											-13.284,
											-4.462
										],
										[
											-17.706,
											-3.188
										],
										[
											-24.219,
											-0.24
										],
										[
											-27.864,
											2.29
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.569,
													613.852
												],
												[
													33.431,
													613.852
												],
												[
													33.431,
													-253.497
												],
												[
													-726.569,
													-253.497
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.569,
													-253.497
												],
												[
													33.431,
													-253.497
												],
												[
													33.431,
													613.852
												],
												[
													-726.569,
													613.852
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									726.569,
									253.497
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 4",
					"np": 4,
					"cix": 2,
					"ix": 4,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-0.737,
											3.047
										],
										[
											-0.479,
											1.395
										],
										[
											-4.004,
											1.275
										],
										[
											-0.757,
											0
										],
										[
											-0.717,
											-0.218
										],
										[
											-2.269,
											-6.433
										],
										[
											-0.339,
											-1.554
										],
										[
											-0.119,
											-3.465
										],
										[
											0,
											-0.737
										],
										[
											0.02,
											-0.718
										],
										[
											0.737,
											-3.047
										],
										[
											0.479,
											-1.394
										],
										[
											3.984,
											-1.274
										],
										[
											0.757,
											0
										],
										[
											0.717,
											0.219
										],
										[
											2.27,
											6.454
										],
										[
											0.338,
											1.554
										],
										[
											0.14,
											3.466
										],
										[
											0,
											0.737
										],
										[
											-0.04,
											0.737
										]
									],
									"o": [
										[
											0.338,
											-1.554
										],
										[
											2.27,
											-6.433
										],
										[
											0.717,
											-0.218
										],
										[
											0.757,
											0
										],
										[
											3.984,
											1.275
										],
										[
											0.479,
											1.395
										],
										[
											0.737,
											3.047
										],
										[
											0.04,
											0.737
										],
										[
											0,
											0.737
										],
										[
											-0.139,
											3.466
										],
										[
											-0.339,
											1.554
										],
										[
											-2.269,
											6.454
										],
										[
											-0.717,
											0.219
										],
										[
											-0.757,
											0
										],
										[
											-4.004,
											-1.274
										],
										[
											-0.479,
											-1.394
										],
										[
											-0.737,
											-3.047
										],
										[
											-0.019,
											-0.718
										],
										[
											0,
											-0.737
										],
										[
											0.119,
											-3.465
										]
									],
									"v": [
										[
											-13.234,
											-14.281
										],
										[
											-11.979,
											-18.703
										],
										[
											-2.2,
											-31.052
										],
										[
											0.011,
											-31.389
										],
										[
											2.221,
											-31.052
										],
										[
											12,
											-18.703
										],
										[
											13.256,
											-14.281
										],
										[
											14.57,
											-4.461
										],
										[
											14.63,
											-2.25
										],
										[
											14.59,
											-0.06
										],
										[
											13.256,
											9.76
										],
										[
											12,
											14.181
										],
										[
											2.221,
											26.53
										],
										[
											0.011,
											26.869
										],
										[
											-2.2,
											26.53
										],
										[
											-11.979,
											14.181
										],
										[
											-13.234,
											9.76
										],
										[
											-14.569,
											-0.06
										],
										[
											-14.608,
											-2.25
										],
										[
											-14.548,
											-4.461
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-0.02,
											-0.718
										],
										[
											-0.816,
											-3.425
										],
										[
											-0.478,
											-1.394
										],
										[
											-1.832,
											-2.45
										],
										[
											-4.521,
											0
										],
										[
											-3.246,
											4.481
										],
										[
											-1.175,
											3.406
										],
										[
											-0.379,
											1.534
										],
										[
											-0.14,
											3.944
										],
										[
											0,
											0.737
										],
										[
											0.019,
											0.717
										],
										[
											0.816,
											3.426
										],
										[
											0.479,
											1.394
										],
										[
											1.812,
											2.47
										],
										[
											3.426,
											0.238
										],
										[
											0.736,
											0
										],
										[
											0.717,
											-0.08
										],
										[
											3.008,
											-1.374
										],
										[
											1.175,
											-3.407
										],
										[
											0.379,
											-1.534
										],
										[
											0.14,
											-3.944
										],
										[
											0,
											-0.737
										]
									],
									"o": [
										[
											0.14,
											3.944
										],
										[
											0.379,
											1.534
										],
										[
											1.195,
											3.466
										],
										[
											3.207,
											4.422
										],
										[
											4.541,
											0
										],
										[
											1.773,
											-2.45
										],
										[
											0.479,
											-1.394
										],
										[
											0.816,
											-3.425
										],
										[
											0.019,
											-0.718
										],
										[
											0,
											-0.737
										],
										[
											-0.14,
											-3.944
										],
										[
											-0.379,
											-1.534
										],
										[
											-1.194,
											-3.446
										],
										[
											-2.969,
											-1.335
										],
										[
											-0.717,
											-0.08
										],
										[
											-0.737,
											0
										],
										[
											-3.426,
											0.258
										],
										[
											-1.792,
											2.45
										],
										[
											-0.478,
											1.394
										],
										[
											-0.816,
											3.426
										],
										[
											-0.02,
											0.717
										],
										[
											0,
											0.737
										]
									],
									"v": [
										[
											-19.11,
											-0.06
										],
										[
											-17.656,
											11.034
										],
										[
											-16.381,
											15.435
										],
										[
											-11.82,
											24.379
										],
										[
											0.011,
											31.409
										],
										[
											11.921,
											24.28
										],
										[
											16.382,
											15.435
										],
										[
											17.658,
											11.034
										],
										[
											19.112,
											-0.06
										],
										[
											19.151,
											-2.25
										],
										[
											19.112,
											-4.461
										],
										[
											17.658,
											-15.555
										],
										[
											16.382,
											-19.956
										],
										[
											11.842,
											-28.899
										],
										[
											2.221,
											-31.31
										],
										[
											0.011,
											-31.409
										],
										[
											-2.2,
											-31.31
										],
										[
											-11.9,
											-28.8
										],
										[
											-16.381,
											-19.956
										],
										[
											-17.656,
											-15.555
										],
										[
											-19.11,
											-4.461
										],
										[
											-19.15,
											-2.25
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.52,
													628.073
												],
												[
													33.48,
													628.073
												],
												[
													33.48,
													-239.276
												],
												[
													-726.52,
													-239.276
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.52,
													-239.276
												],
												[
													33.48,
													-239.276
												],
												[
													33.48,
													628.073
												],
												[
													-726.52,
													628.073
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									726.52,
									239.276
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 5",
					"np": 6,
					"cix": 2,
					"ix": 5,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-3.684,
											-5.378
										],
										[
											-0.996,
											-1.135
										],
										[
											-9.779,
											0
										],
										[
											-6.175,
											6.911
										],
										[
											-0.857,
											1.254
										],
										[
											0,
											6.951
										],
										[
											3.645,
											5.378
										],
										[
											1.016,
											1.116
										],
										[
											1.434,
											-0.776
										],
										[
											-0.837,
											-1.294
										],
										[
											-0.379,
											-5.158
										],
										[
											0,
											-0.737
										],
										[
											0.079,
											-0.718
										],
										[
											2.748,
											-4.083
										],
										[
											1.055,
											-1.136
										],
										[
											3.526,
											-1.614
										],
										[
											3.426,
											-0.259
										],
										[
											0.737,
											0
										],
										[
											0.717,
											0.08
										],
										[
											2.968,
											1.335
										],
										[
											2.648,
											2.848
										],
										[
											0.856,
											1.275
										],
										[
											0.398,
											5.158
										],
										[
											0,
											0.737
										],
										[
											-0.08,
											0.717
										],
										[
											-2.749,
											4.083
										],
										[
											-1.035,
											1.116
										],
										[
											1.095,
											0.936
										],
										[
											0.856,
											-1.254
										],
										[
											0,
											-6.971
										]
									],
									"o": [
										[
											0.856,
											1.255
										],
										[
											6.233,
											6.951
										],
										[
											9.958,
											0
										],
										[
											1.016,
											-1.136
										],
										[
											3.645,
											-5.378
										],
										[
											0,
											-6.971
										],
										[
											-0.857,
											-1.254
										],
										[
											-1.076,
											0.917
										],
										[
											1.055,
											1.136
										],
										[
											2.769,
											4.084
										],
										[
											0.079,
											0.717
										],
										[
											0,
											0.737
										],
										[
											-0.379,
											5.138
										],
										[
											-0.877,
											1.274
										],
										[
											-2.629,
											2.808
										],
										[
											-3.007,
											1.374
										],
										[
											-0.717,
											0.08
										],
										[
											-0.737,
											0
										],
										[
											-3.426,
											-0.239
										],
										[
											-3.625,
											-1.593
										],
										[
											-1.056,
											-1.135
										],
										[
											-2.75,
											-4.082
										],
										[
											-0.06,
											-0.718
										],
										[
											0,
											-0.737
										],
										[
											0.378,
											-5.138
										],
										[
											0.876,
											-1.274
										],
										[
											-1.474,
											-0.776
										],
										[
											-1.015,
											1.115
										],
										[
											-3.645,
											5.378
										],
										[
											0,
											6.931
										]
									],
									"v": [
										[
											-27.72,
											13.135
										],
										[
											-24.931,
											16.72
										],
										[
											0.105,
											28.053
										],
										[
											25.201,
											16.78
										],
										[
											28.009,
											13.196
										],
										[
											33.785,
											-5.626
										],
										[
											28.009,
											-24.468
										],
										[
											25.201,
											-28.053
										],
										[
											21.416,
											-25.504
										],
										[
											24.264,
											-21.879
										],
										[
											29.144,
											-7.837
										],
										[
											29.244,
											-5.626
										],
										[
											29.144,
											-3.436
										],
										[
											24.245,
											10.566
										],
										[
											21.337,
											14.191
										],
										[
											12.015,
											20.903
										],
										[
											2.315,
											23.413
										],
										[
											0.105,
											23.512
										],
										[
											-2.106,
											23.413
										],
										[
											-11.726,
											21.002
										],
										[
											-21.206,
											14.23
										],
										[
											-24.074,
											10.605
										],
										[
											-28.954,
											-3.436
										],
										[
											-29.034,
											-5.626
										],
										[
											-28.934,
											-7.837
										],
										[
											-24.015,
											-21.86
										],
										[
											-21.127,
											-25.465
										],
										[
											-24.991,
											-28.033
										],
										[
											-27.799,
											-24.468
										],
										[
											-33.575,
											-5.626
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.425,
													624.697
												],
												[
													33.575,
													624.697
												],
												[
													33.575,
													-242.652
												],
												[
													-726.425,
													-242.652
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.425,
													-242.652
												],
												[
													33.575,
													-242.652
												],
												[
													33.575,
													624.697
												],
												[
													-726.425,
													624.697
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									726.425,
									242.652
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 6",
					"np": 4,
					"cix": 2,
					"ix": 6,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-15.895,
											0
										],
										[
											0,
											-15.895
										],
										[
											15.896,
											0
										],
										[
											0,
											15.895
										]
									],
									"o": [
										[
											16.274,
											0
										],
										[
											0,
											15.895
										],
										[
											-16.273,
											0
										],
										[
											0,
											-15.895
										]
									],
									"v": [
										[
											0.103,
											-29.141
										],
										[
											29.245,
											0
										],
										[
											0.103,
											29.141
										],
										[
											-29.038,
											0
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-18.165,
											0
										],
										[
											0,
											18.545
										],
										[
											18.545,
											0
										],
										[
											0,
											-18.544
										]
									],
									"o": [
										[
											18.545,
											0
										],
										[
											0,
											-18.544
										],
										[
											-18.544,
											0
										],
										[
											0,
											18.545
										]
									],
									"v": [
										[
											0.103,
											33.683
										],
										[
											33.787,
											0
										],
										[
											0.103,
											-33.683
										],
										[
											-33.58,
											0
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.42,
													630.333
												],
												[
													33.58,
													630.333
												],
												[
													33.58,
													-237.016
												],
												[
													-726.42,
													-237.016
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.42,
													-237.016
												],
												[
													33.58,
													-237.016
												],
												[
													33.58,
													630.333
												],
												[
													-726.42,
													630.333
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									726.42,
									237.016
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 7",
					"np": 6,
					"cix": 2,
					"ix": 7,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.737,
											0
										],
										[
											-0.717,
											-0.08
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0.717,
											-0.08
										],
										[
											0.736,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-2.211,
											30.533
										],
										[
											-2.211,
											-30.433
										],
										[
											0,
											-30.533
										],
										[
											2.21,
											-30.433
										],
										[
											2.21,
											30.533
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.53,
													628.949
												],
												[
													33.47,
													628.949
												],
												[
													33.47,
													-238.4
												],
												[
													-726.53,
													-238.4
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.53,
													-238.4
												],
												[
													33.47,
													-238.4
												],
												[
													33.47,
													628.949
												],
												[
													-726.53,
													628.949
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									726.53,
									238.4
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 8",
					"np": 4,
					"cix": 2,
					"ix": 8,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-31.91,
											-2.21
										],
										[
											31.911,
											-2.21
										],
										[
											31.911,
											2.21
										],
										[
											-31.91,
											2.21
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.522,
													630.333
												],
												[
													33.478,
													630.333
												],
												[
													33.478,
													-237.015
												],
												[
													-726.522,
													-237.015
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.522,
													-237.015
												],
												[
													33.478,
													-237.015
												],
												[
													33.478,
													630.333
												],
												[
													-726.522,
													630.333
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									726.522,
									237.015
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 9",
					"np": 4,
					"cix": 2,
					"ix": 9,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-1.394,
											-0.796
										],
										[
											-2.37,
											-0.817
										],
										[
											-1.534,
											-0.379
										],
										[
											-3.924,
											-0.14
										],
										[
											-0.737,
											0
										],
										[
											-0.717,
											0.02
										],
										[
											-3.406,
											0.797
										],
										[
											-1.395,
											0.478
										],
										[
											-1.952,
											1.135
										],
										[
											-1.115,
											0.916
										],
										[
											1.015,
											1.115
										],
										[
											1.434,
											-0.776
										],
										[
											1.813,
											-0.637
										],
										[
											1.535,
											-0.359
										],
										[
											3.446,
											-0.12
										],
										[
											0.736,
											0
										],
										[
											0.737,
											0.039
										],
										[
											3.027,
											0.717
										],
										[
											1.375,
											0.478
										],
										[
											1.454,
											0.797
										],
										[
											1.095,
											0.936
										],
										[
											0.856,
											-1.255
										]
									],
									"o": [
										[
											1.912,
											1.135
										],
										[
											1.395,
											0.478
										],
										[
											3.405,
											0.797
										],
										[
											0.717,
											0.02
										],
										[
											0.736,
											0
										],
										[
											3.924,
											-0.14
										],
										[
											1.533,
											-0.379
										],
										[
											2.389,
											-0.837
										],
										[
											1.374,
											-0.796
										],
										[
											-0.856,
											-1.255
										],
										[
											-1.076,
											0.916
										],
										[
											-1.474,
											0.817
										],
										[
											-1.374,
											0.478
										],
										[
											-3.027,
											0.717
										],
										[
											-0.736,
											0.039
										],
										[
											-0.737,
											0
										],
										[
											-3.446,
											-0.12
										],
										[
											-1.554,
											-0.359
										],
										[
											-1.773,
											-0.617
										],
										[
											-1.474,
											-0.777
										],
										[
											-1.015,
											1.115
										],
										[
											1.115,
											0.936
										]
									],
									"v": [
										[
											-24.119,
											0.259
										],
										[
											-17.667,
											3.187
										],
										[
											-13.244,
											4.462
										],
										[
											-2.21,
											5.896
										],
										[
											0.001,
											5.935
										],
										[
											2.211,
											5.896
										],
										[
											13.246,
											4.462
										],
										[
											17.648,
											3.187
										],
										[
											24.16,
											0.239
										],
										[
											27.904,
											-2.35
										],
										[
											25.096,
											-5.935
										],
										[
											21.312,
											-3.386
										],
										[
											16.372,
											-1.215
										],
										[
											11.99,
											0.04
										],
										[
											2.211,
											1.335
										],
										[
											0.001,
											1.394
										],
										[
											-2.21,
											1.335
										],
										[
											-11.99,
											0.04
										],
										[
											-16.391,
											-1.215
										],
										[
											-21.232,
											-3.346
										],
										[
											-25.095,
											-5.915
										],
										[
											-27.904,
											-2.35
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.53,
													646.815
												],
												[
													33.47,
													646.815
												],
												[
													33.47,
													-220.534
												],
												[
													-726.53,
													-220.534
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.53,
													-220.534
												],
												[
													33.47,
													-220.534
												],
												[
													33.47,
													646.815
												],
												[
													-726.53,
													646.815
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									726.53,
									220.534
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 10",
					"np": 4,
					"cix": 2,
					"ix": 10,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-0.996,
											-1.135
										],
										[
											-1.414,
											0.758
										],
										[
											-1.792,
											0.638
										],
										[
											-1.554,
											0.359
										],
										[
											-3.446,
											0.12
										],
										[
											-0.737,
											0
										],
										[
											-0.736,
											-0.04
										],
										[
											-3.027,
											-0.716
										],
										[
											-1.374,
											-0.477
										],
										[
											-1.455,
											-0.797
										],
										[
											-1.096,
											-0.936
										],
										[
											-0.856,
											1.254
										],
										[
											1.393,
											0.816
										],
										[
											2.37,
											0.817
										],
										[
											1.533,
											0.379
										],
										[
											3.924,
											0.14
										],
										[
											0.736,
											0
										],
										[
											0.717,
											-0.02
										],
										[
											3.405,
											-0.796
										],
										[
											1.395,
											-0.478
										],
										[
											1.932,
											-1.135
										],
										[
											1.076,
											-0.896
										]
									],
									"o": [
										[
											1.075,
											-0.896
										],
										[
											1.473,
											-0.816
										],
										[
											1.375,
											-0.477
										],
										[
											3.027,
											-0.716
										],
										[
											0.737,
											-0.04
										],
										[
											0.736,
											0
										],
										[
											3.446,
											0.12
										],
										[
											1.535,
											0.359
										],
										[
											1.774,
											0.618
										],
										[
											1.473,
											0.797
										],
										[
											1.015,
											-1.136
										],
										[
											-1.115,
											-0.936
										],
										[
											-1.933,
											-1.096
										],
										[
											-1.395,
											-0.478
										],
										[
											-3.406,
											-0.796
										],
										[
											-0.717,
											-0.02
										],
										[
											-0.737,
											0
										],
										[
											-3.924,
											0.14
										],
										[
											-1.534,
											0.379
										],
										[
											-2.39,
											0.837
										],
										[
											-1.334,
											0.777
										],
										[
											0.856,
											1.255
										]
									],
									"v": [
										[
											-25.075,
											5.875
										],
										[
											-21.35,
											3.385
										],
										[
											-16.431,
											1.215
										],
										[
											-12.029,
											-0.04
										],
										[
											-2.25,
											-1.335
										],
										[
											-0.039,
											-1.395
										],
										[
											2.171,
											-1.335
										],
										[
											11.95,
											-0.04
										],
										[
											16.332,
											1.215
										],
										[
											21.193,
											3.346
										],
										[
											25.057,
											5.936
										],
										[
											27.864,
											2.35
										],
										[
											24.101,
											-0.279
										],
										[
											17.608,
											-3.188
										],
										[
											13.206,
											-4.462
										],
										[
											2.171,
											-5.896
										],
										[
											-0.039,
											-5.936
										],
										[
											-2.25,
											-5.896
										],
										[
											-13.284,
											-4.462
										],
										[
											-17.706,
											-3.188
										],
										[
											-24.219,
											-0.24
										],
										[
											-27.864,
											2.29
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.569,
													613.852
												],
												[
													33.431,
													613.852
												],
												[
													33.431,
													-253.497
												],
												[
													-726.569,
													-253.497
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.569,
													-253.497
												],
												[
													33.431,
													-253.497
												],
												[
													33.431,
													613.852
												],
												[
													-726.569,
													613.852
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									726.569,
									253.497
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 11",
					"np": 4,
					"cix": 2,
					"ix": 11,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-0.737,
											3.047
										],
										[
											-0.479,
											1.395
										],
										[
											-4.004,
											1.275
										],
										[
											-0.757,
											0
										],
										[
											-0.717,
											-0.218
										],
										[
											-2.269,
											-6.433
										],
										[
											-0.339,
											-1.554
										],
										[
											-0.119,
											-3.465
										],
										[
											0,
											-0.737
										],
										[
											0.02,
											-0.718
										],
										[
											0.737,
											-3.047
										],
										[
											0.479,
											-1.394
										],
										[
											3.984,
											-1.274
										],
										[
											0.757,
											0
										],
										[
											0.717,
											0.219
										],
										[
											2.27,
											6.454
										],
										[
											0.338,
											1.554
										],
										[
											0.14,
											3.466
										],
										[
											0,
											0.737
										],
										[
											-0.04,
											0.737
										]
									],
									"o": [
										[
											0.338,
											-1.554
										],
										[
											2.27,
											-6.433
										],
										[
											0.717,
											-0.218
										],
										[
											0.757,
											0
										],
										[
											3.984,
											1.275
										],
										[
											0.479,
											1.395
										],
										[
											0.737,
											3.047
										],
										[
											0.04,
											0.737
										],
										[
											0,
											0.737
										],
										[
											-0.139,
											3.466
										],
										[
											-0.339,
											1.554
										],
										[
											-2.269,
											6.454
										],
										[
											-0.717,
											0.219
										],
										[
											-0.757,
											0
										],
										[
											-4.004,
											-1.274
										],
										[
											-0.479,
											-1.394
										],
										[
											-0.737,
											-3.047
										],
										[
											-0.019,
											-0.718
										],
										[
											0,
											-0.737
										],
										[
											0.119,
											-3.465
										]
									],
									"v": [
										[
											-13.234,
											-14.281
										],
										[
											-11.979,
											-18.703
										],
										[
											-2.2,
											-31.052
										],
										[
											0.011,
											-31.389
										],
										[
											2.221,
											-31.052
										],
										[
											12,
											-18.703
										],
										[
											13.256,
											-14.281
										],
										[
											14.57,
											-4.461
										],
										[
											14.63,
											-2.25
										],
										[
											14.59,
											-0.06
										],
										[
											13.256,
											9.76
										],
										[
											12,
											14.181
										],
										[
											2.221,
											26.53
										],
										[
											0.011,
											26.869
										],
										[
											-2.2,
											26.53
										],
										[
											-11.979,
											14.181
										],
										[
											-13.234,
											9.76
										],
										[
											-14.569,
											-0.06
										],
										[
											-14.608,
											-2.25
										],
										[
											-14.548,
											-4.461
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-0.02,
											-0.718
										],
										[
											-0.816,
											-3.425
										],
										[
											-0.478,
											-1.394
										],
										[
											-1.832,
											-2.45
										],
										[
											-4.521,
											0
										],
										[
											-3.246,
											4.481
										],
										[
											-1.175,
											3.406
										],
										[
											-0.379,
											1.534
										],
										[
											-0.14,
											3.944
										],
										[
											0,
											0.737
										],
										[
											0.019,
											0.717
										],
										[
											0.816,
											3.426
										],
										[
											0.479,
											1.394
										],
										[
											1.812,
											2.47
										],
										[
											3.426,
											0.238
										],
										[
											0.736,
											0
										],
										[
											0.717,
											-0.08
										],
										[
											3.008,
											-1.374
										],
										[
											1.175,
											-3.407
										],
										[
											0.379,
											-1.534
										],
										[
											0.14,
											-3.944
										],
										[
											0,
											-0.737
										]
									],
									"o": [
										[
											0.14,
											3.944
										],
										[
											0.379,
											1.534
										],
										[
											1.195,
											3.466
										],
										[
											3.207,
											4.422
										],
										[
											4.541,
											0
										],
										[
											1.773,
											-2.45
										],
										[
											0.479,
											-1.394
										],
										[
											0.816,
											-3.425
										],
										[
											0.019,
											-0.718
										],
										[
											0,
											-0.737
										],
										[
											-0.14,
											-3.944
										],
										[
											-0.379,
											-1.534
										],
										[
											-1.194,
											-3.446
										],
										[
											-2.969,
											-1.335
										],
										[
											-0.717,
											-0.08
										],
										[
											-0.737,
											0
										],
										[
											-3.426,
											0.258
										],
										[
											-1.792,
											2.45
										],
										[
											-0.478,
											1.394
										],
										[
											-0.816,
											3.426
										],
										[
											-0.02,
											0.717
										],
										[
											0,
											0.737
										]
									],
									"v": [
										[
											-19.11,
											-0.06
										],
										[
											-17.656,
											11.034
										],
										[
											-16.381,
											15.435
										],
										[
											-11.82,
											24.379
										],
										[
											0.011,
											31.409
										],
										[
											11.921,
											24.28
										],
										[
											16.382,
											15.435
										],
										[
											17.658,
											11.034
										],
										[
											19.112,
											-0.06
										],
										[
											19.151,
											-2.25
										],
										[
											19.112,
											-4.461
										],
										[
											17.658,
											-15.555
										],
										[
											16.382,
											-19.956
										],
										[
											11.842,
											-28.899
										],
										[
											2.221,
											-31.31
										],
										[
											0.011,
											-31.409
										],
										[
											-2.2,
											-31.31
										],
										[
											-11.9,
											-28.8
										],
										[
											-16.381,
											-19.956
										],
										[
											-17.656,
											-15.555
										],
										[
											-19.11,
											-4.461
										],
										[
											-19.15,
											-2.25
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.52,
													628.073
												],
												[
													33.48,
													628.073
												],
												[
													33.48,
													-239.276
												],
												[
													-726.52,
													-239.276
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.52,
													-239.276
												],
												[
													33.48,
													-239.276
												],
												[
													33.48,
													628.073
												],
												[
													-726.52,
													628.073
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									726.52,
									239.276
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 12",
					"np": 6,
					"cix": 2,
					"ix": 12,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-3.684,
											-5.378
										],
										[
											-0.996,
											-1.135
										],
										[
											-9.779,
											0
										],
										[
											-6.175,
											6.911
										],
										[
											-0.857,
											1.254
										],
										[
											0,
											6.951
										],
										[
											3.645,
											5.378
										],
										[
											1.016,
											1.116
										],
										[
											1.434,
											-0.776
										],
										[
											-0.837,
											-1.294
										],
										[
											-0.379,
											-5.158
										],
										[
											0,
											-0.737
										],
										[
											0.079,
											-0.718
										],
										[
											2.748,
											-4.083
										],
										[
											1.055,
											-1.136
										],
										[
											3.526,
											-1.614
										],
										[
											3.426,
											-0.259
										],
										[
											0.737,
											0
										],
										[
											0.717,
											0.08
										],
										[
											2.968,
											1.335
										],
										[
											2.648,
											2.848
										],
										[
											0.856,
											1.275
										],
										[
											0.398,
											5.158
										],
										[
											0,
											0.737
										],
										[
											-0.08,
											0.717
										],
										[
											-2.749,
											4.083
										],
										[
											-1.035,
											1.116
										],
										[
											1.095,
											0.936
										],
										[
											0.856,
											-1.254
										],
										[
											0,
											-6.971
										]
									],
									"o": [
										[
											0.856,
											1.255
										],
										[
											6.233,
											6.951
										],
										[
											9.958,
											0
										],
										[
											1.016,
											-1.136
										],
										[
											3.645,
											-5.378
										],
										[
											0,
											-6.971
										],
										[
											-0.857,
											-1.254
										],
										[
											-1.076,
											0.917
										],
										[
											1.055,
											1.136
										],
										[
											2.769,
											4.084
										],
										[
											0.079,
											0.717
										],
										[
											0,
											0.737
										],
										[
											-0.379,
											5.138
										],
										[
											-0.877,
											1.274
										],
										[
											-2.629,
											2.808
										],
										[
											-3.007,
											1.374
										],
										[
											-0.717,
											0.08
										],
										[
											-0.737,
											0
										],
										[
											-3.426,
											-0.239
										],
										[
											-3.625,
											-1.593
										],
										[
											-1.056,
											-1.135
										],
										[
											-2.75,
											-4.082
										],
										[
											-0.06,
											-0.718
										],
										[
											0,
											-0.737
										],
										[
											0.378,
											-5.138
										],
										[
											0.876,
											-1.274
										],
										[
											-1.474,
											-0.776
										],
										[
											-1.015,
											1.115
										],
										[
											-3.645,
											5.378
										],
										[
											0,
											6.931
										]
									],
									"v": [
										[
											-27.72,
											13.135
										],
										[
											-24.931,
											16.72
										],
										[
											0.105,
											28.053
										],
										[
											25.201,
											16.78
										],
										[
											28.009,
											13.196
										],
										[
											33.785,
											-5.626
										],
										[
											28.009,
											-24.468
										],
										[
											25.201,
											-28.053
										],
										[
											21.416,
											-25.504
										],
										[
											24.264,
											-21.879
										],
										[
											29.144,
											-7.837
										],
										[
											29.244,
											-5.626
										],
										[
											29.144,
											-3.436
										],
										[
											24.245,
											10.566
										],
										[
											21.337,
											14.191
										],
										[
											12.015,
											20.903
										],
										[
											2.315,
											23.413
										],
										[
											0.105,
											23.512
										],
										[
											-2.106,
											23.413
										],
										[
											-11.726,
											21.002
										],
										[
											-21.206,
											14.23
										],
										[
											-24.074,
											10.605
										],
										[
											-28.954,
											-3.436
										],
										[
											-29.034,
											-5.626
										],
										[
											-28.934,
											-7.837
										],
										[
											-24.015,
											-21.86
										],
										[
											-21.127,
											-25.465
										],
										[
											-24.991,
											-28.033
										],
										[
											-27.799,
											-24.468
										],
										[
											-33.575,
											-5.626
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.425,
													624.697
												],
												[
													33.575,
													624.697
												],
												[
													33.575,
													-242.652
												],
												[
													-726.425,
													-242.652
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.425,
													-242.652
												],
												[
													33.575,
													-242.652
												],
												[
													33.575,
													624.697
												],
												[
													-726.425,
													624.697
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									726.425,
									242.652
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 13",
					"np": 4,
					"cix": 2,
					"ix": 13,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-15.895,
											0
										],
										[
											0,
											-15.895
										],
										[
											15.896,
											0
										],
										[
											0,
											15.895
										]
									],
									"o": [
										[
											16.274,
											0
										],
										[
											0,
											15.895
										],
										[
											-16.273,
											0
										],
										[
											0,
											-15.895
										]
									],
									"v": [
										[
											0.103,
											-29.141
										],
										[
											29.245,
											0
										],
										[
											0.103,
											29.141
										],
										[
											-29.038,
											0
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-18.165,
											0
										],
										[
											0,
											18.545
										],
										[
											18.545,
											0
										],
										[
											0,
											-18.544
										]
									],
									"o": [
										[
											18.545,
											0
										],
										[
											0,
											-18.544
										],
										[
											-18.544,
											0
										],
										[
											0,
											18.545
										]
									],
									"v": [
										[
											0.103,
											33.683
										],
										[
											33.787,
											0
										],
										[
											0.103,
											-33.683
										],
										[
											-33.58,
											0
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.42,
													630.333
												],
												[
													33.58,
													630.333
												],
												[
													33.58,
													-237.016
												],
												[
													-726.42,
													-237.016
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-726.42,
													-237.016
												],
												[
													33.58,
													-237.016
												],
												[
													33.58,
													630.333
												],
												[
													-726.42,
													630.333
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									726.42,
									237.016
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 14",
					"np": 6,
					"cix": 2,
					"ix": 14,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 75,
			"st": 15,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 4,
			"nm": "Devices Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"n": [
								"0p833_0p833_0p167_0p167"
							],
							"t": 36,
							"s": [
								19
							],
							"e": [
								100
							]
						},
						{
							"t": 40
						}
					],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						380,
						433.674,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						380,
						433.674,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											1.253,
											0
										],
										[
											0,
											0
										],
										[
											0,
											1.254
										],
										[
											-1.254,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-1.253
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-1.254,
											0
										],
										[
											0,
											-1.253
										],
										[
											0,
											0
										],
										[
											1.253,
											0
										],
										[
											0,
											1.254
										]
									],
									"v": [
										[
											9.743,
											2.269
										],
										[
											-9.742,
											2.269
										],
										[
											-12.013,
											0
										],
										[
											-9.742,
											-2.27
										],
										[
											9.743,
											-2.27
										],
										[
											12.013,
											0
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-717.201,
													209.135
												],
												[
													42.799,
													209.135
												],
												[
													42.799,
													-658.214
												],
												[
													-717.201,
													-658.214
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-717.201,
													-658.214
												],
												[
													42.799,
													-658.214
												],
												[
													42.799,
													209.135
												],
												[
													-717.201,
													209.135
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									717.201,
									658.214
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 4,
					"cix": 2,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											4.979,
											-2.614
										],
										[
											-4.979,
											-2.614
										],
										[
											-4.979,
											2.614
										],
										[
											4.979,
											2.614
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											2.796,
											0.432
										],
										[
											-2.798,
											0.432
										],
										[
											-2.798,
											-0.432
										],
										[
											2.796,
											-0.432
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-717.202,
													213.741
												],
												[
													42.798,
													213.741
												],
												[
													42.798,
													-653.608
												],
												[
													-717.202,
													-653.608
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-717.202,
													-653.608
												],
												[
													42.798,
													-653.608
												],
												[
													42.798,
													213.741
												],
												[
													-717.202,
													213.741
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									717.202,
									653.608
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 2",
					"np": 6,
					"cix": 2,
					"ix": 2,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-0.585,
											0
										],
										[
											0,
											0.585
										],
										[
											0.584,
											0
										],
										[
											0,
											-0.584
										]
									],
									"o": [
										[
											0.584,
											0
										],
										[
											0,
											-0.584
										],
										[
											-0.585,
											0
										],
										[
											0,
											0.585
										]
									],
									"v": [
										[
											0,
											1.058
										],
										[
											1.058,
											-0.001
										],
										[
											0,
											-1.058
										],
										[
											-1.059,
											-0.001
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-743.812,
													209.803
												],
												[
													16.188,
													209.803
												],
												[
													16.188,
													-657.546
												],
												[
													-743.812,
													-657.546
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-743.812,
													-657.546
												],
												[
													16.188,
													-657.546
												],
												[
													16.188,
													209.803
												],
												[
													-743.812,
													209.803
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									1,
									1,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									743.812,
									657.546
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 3",
					"np": 4,
					"cix": 2,
					"ix": 3,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-0.584,
											0
										],
										[
											0,
											0.584
										],
										[
											0.585,
											0
										],
										[
											0,
											-0.584
										]
									],
									"o": [
										[
											0.585,
											0
										],
										[
											0,
											-0.584
										],
										[
											-0.584,
											0
										],
										[
											0,
											0.584
										]
									],
									"v": [
										[
											0,
											1.058
										],
										[
											1.059,
											0
										],
										[
											0,
											-1.058
										],
										[
											-1.058,
											0
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-718.056,
													251.486
												],
												[
													41.944,
													251.486
												],
												[
													41.944,
													-615.863
												],
												[
													-718.056,
													-615.863
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-718.056,
													-615.863
												],
												[
													41.944,
													-615.863
												],
												[
													41.944,
													251.486
												],
												[
													-718.056,
													251.486
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									1,
									1,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									718.056,
									615.863
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 4",
					"np": 4,
					"cix": 2,
					"ix": 4,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-2.191
										],
										[
											0,
											0
										],
										[
											-2.211,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-2.211,
											0
										],
										[
											0,
											0
										],
										[
											0,
											2.192
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-24.657,
											-14.788
										],
										[
											-1.992,
											-14.788
										],
										[
											-1.992,
											-18.892
										],
										[
											-24.776,
											-18.892
										],
										[
											-28.76,
											-14.908
										],
										[
											-28.76,
											14.908
										],
										[
											-24.776,
											18.892
										],
										[
											17.985,
											18.892
										],
										[
											17.985,
											14.769
										],
										[
											-24.657,
											14.769
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											2.211,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-2.191
										]
									],
									"v": [
										[
											24.778,
											-18.892
										],
										[
											1.992,
											-18.892
										],
										[
											1.992,
											-14.788
										],
										[
											24.657,
											-14.788
										],
										[
											24.657,
											-6.144
										],
										[
											28.76,
											-6.144
										],
										[
											28.76,
											-14.908
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-718.064,
													234.651
												],
												[
													41.936,
													234.651
												],
												[
													41.936,
													-632.698
												],
												[
													-718.064,
													-632.698
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-718.064,
													-632.698
												],
												[
													41.936,
													-632.698
												],
												[
													41.936,
													234.651
												],
												[
													-718.064,
													234.651
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									718.064,
									632.698
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 5",
					"np": 6,
					"cix": 2,
					"ix": 5,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											3.784,
											1.504
										],
										[
											-3.784,
											1.504
										],
										[
											-3.784,
											-1.504
										],
										[
											3.784,
											-1.504
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-749.593,
													211.228
												],
												[
													10.407,
													211.228
												],
												[
													10.407,
													-656.121
												],
												[
													-749.593,
													-656.121
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-749.593,
													-656.121
												],
												[
													10.407,
													-656.121
												],
												[
													10.407,
													211.228
												],
												[
													-749.593,
													211.228
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									749.593,
									656.121
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 6",
					"np": 4,
					"cix": 2,
					"ix": 6,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											3.625,
											1.504
										],
										[
											-3.625,
											1.504
										],
										[
											-3.625,
											-1.504
										],
										[
											3.625,
											-1.504
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-738.2,
													211.228
												],
												[
													21.8,
													211.228
												],
												[
													21.8,
													-656.121
												],
												[
													-738.2,
													-656.121
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-738.2,
													-656.121
												],
												[
													21.8,
													-656.121
												],
												[
													21.8,
													211.228
												],
												[
													-738.2,
													211.228
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									738.2,
									656.121
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 7",
					"np": 4,
					"cix": 2,
					"ix": 7,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											1.434,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-1.454
										],
										[
											0,
											0
										],
										[
											-1.453,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											1.455
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-1.453,
											0
										],
										[
											0,
											0
										],
										[
											0,
											1.455
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											1.434,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-1.454
										]
									],
									"v": [
										[
											9.143,
											-18.951
										],
										[
											-9.122,
											-18.951
										],
										[
											-11.751,
											-16.321
										],
										[
											-11.751,
											16.322
										],
										[
											-9.122,
											18.952
										],
										[
											-1.991,
											18.952
										],
										[
											-1.991,
											14.968
										],
										[
											-7.767,
											14.968
										],
										[
											-7.767,
											-14.969
										],
										[
											7.769,
											-14.969
										],
										[
											7.769,
											14.968
										],
										[
											1.993,
											14.968
										],
										[
											1.993,
											18.952
										],
										[
											9.143,
											18.952
										],
										[
											11.752,
											16.322
										],
										[
											11.752,
											-16.321
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-743.816,
													225.827
												],
												[
													16.184,
													225.827
												],
												[
													16.184,
													-641.522
												],
												[
													-743.816,
													-641.522
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-743.816,
													-641.522
												],
												[
													16.184,
													-641.522
												],
												[
													16.184,
													225.827
												],
												[
													-743.816,
													225.827
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									743.816,
									641.522
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 8",
					"np": 4,
					"cix": 2,
					"ix": 8,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": -2,
			"op": 89,
			"st": 14,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 5,
			"ty": 4,
			"nm": "Position Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"n": [
								"0p833_0p833_0p167_0p167"
							],
							"t": 44,
							"s": [
								20
							],
							"e": [
								100
							]
						},
						{
							"t": 48
						}
					],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						380,
						433.674,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						380,
						433.674,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											3.785
										],
										[
											3.784,
											0
										],
										[
											0,
											-3.784
										],
										[
											-3.785,
											0
										]
									],
									"o": [
										[
											0,
											-3.784
										],
										[
											-3.785,
											0
										],
										[
											0,
											3.785
										],
										[
											3.784,
											0
										]
									],
									"v": [
										[
											6.434,
											-8.894
										],
										[
											-0.378,
											-15.706
										],
										[
											-7.191,
											-8.894
										],
										[
											-0.378,
											-2.082
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											6.056
										],
										[
											-6.434,
											0
										],
										[
											0,
											-6.434
										],
										[
											6.434,
											0
										]
									],
									"o": [
										[
											0,
											-6.055
										],
										[
											6.055,
											0
										],
										[
											0,
											6.056
										],
										[
											-6.434,
											0
										]
									],
									"v": [
										[
											-11.354,
											-8.894
										],
										[
											0,
											-20.248
										],
										[
											11.354,
											-8.894
										],
										[
											0,
											2.46
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 2,
							"ty": "sh",
							"ix": 3,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											10.975,
											0
										],
										[
											0,
											-11.733
										],
										[
											0,
											0
										],
										[
											0,
											11.731
										]
									],
									"o": [
										[
											-11.354,
											0
										],
										[
											0,
											11.731
										],
										[
											0,
											0
										],
										[
											-0.379,
											-11.733
										]
									],
									"v": [
										[
											0,
											-29.331
										],
										[
											-20.437,
											-8.136
										],
										[
											0,
											27.06
										],
										[
											20.437,
											-8.136
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 3",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 3,
							"ty": "sh",
							"ix": 4,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											6.812,
											-8.327
										],
										[
											0,
											0
										],
										[
											0,
											-1.135
										],
										[
											1.136,
											0
										],
										[
											0,
											0
										],
										[
											0,
											1.136
										],
										[
											-1.135,
											0
										],
										[
											0,
											0
										],
										[
											0,
											10.597
										],
										[
											-14.003,
											0
										],
										[
											0,
											-14.003
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											1.136,
											0
										],
										[
											0,
											1.136
										],
										[
											0,
											0
										],
										[
											-1.135,
											0
										],
										[
											0,
											-1.135
										],
										[
											0,
											0
										],
										[
											-6.812,
											-8.704
										],
										[
											0,
											-14.003
										],
										[
											13.624,
											0
										],
										[
											-0.378,
											10.597
										]
									],
									"v": [
										[
											3.785,
											29.331
										],
										[
											13.624,
											29.331
										],
										[
											15.895,
											31.601
										],
										[
											13.624,
											33.872
										],
										[
											-13.625,
											33.872
										],
										[
											-15.895,
											31.601
										],
										[
											-13.625,
											29.331
										],
										[
											-3.785,
											29.331
										],
										[
											-24.978,
											-8.516
										],
										[
											0,
											-33.872
										],
										[
											24.978,
											-8.516
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 4",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-377.544,
													34.112
												],
												[
													382.456,
													34.112
												],
												[
													382.456,
													-833.237
												],
												[
													-377.544,
													-833.237
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-377.544,
													-833.237
												],
												[
													382.456,
													-833.237
												],
												[
													382.456,
													34.112
												],
												[
													-377.544,
													34.112
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 6,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									377.544,
									833.237
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 8,
					"cix": 2,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 75,
			"st": 15,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 6,
			"ty": 4,
			"nm": "Mail Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"n": [
								"0p833_0p833_0p167_0p167"
							],
							"t": 51,
							"s": [
								20
							],
							"e": [
								100
							]
						},
						{
							"t": 55
						}
					],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						380,
						433.674,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						380,
						433.674,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-29.141,
											-10.975
										],
										[
											-29.141,
											29.141
										],
										[
											29.141,
											29.141
										],
										[
											29.141,
											-10.975
										],
										[
											-0.001,
											-29.141
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-7.568,
											4.92
										],
										[
											-24.6,
											-9.082
										],
										[
											-0.378,
											-24.6
										],
										[
											23.844,
											-8.705
										],
										[
											-1.135,
											10.218
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 2,
							"ty": "sh",
							"ix": 3,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											25.094,
											-10.611
										],
										[
											18.982,
											-14.622
										],
										[
											26.861,
											-9.71
										],
										[
											26.861,
											-9.451
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 3",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 3,
							"ty": "sh",
							"ix": 4,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											12.111,
											4.92
										],
										[
											25.357,
											-5.299
										],
										[
											25.357,
											21.951
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 4",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 4,
							"ty": "sh",
							"ix": 5,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-25.357,
											-5.299
										],
										[
											-12.488,
											5.298
										],
										[
											-25.357,
											21.951
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 5",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 5,
							"ty": "sh",
							"ix": 6,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-0.001,
											14.382
										],
										[
											9.083,
											7.191
										],
										[
											23.464,
											25.735
										],
										[
											23.464,
											26.114
										],
										[
											-23.087,
											26.114
										],
										[
											-9.083,
											8.325
										],
										[
											-1.514,
											14.382
										],
										[
											-0.758,
											15.138
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 6",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 6,
							"ty": "sh",
							"ix": 7,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											25.745,
											26.163
										],
										[
											26.288,
											26.861
										],
										[
											25.745,
											26.861
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 7",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									29.351,
									630.019
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 9,
					"cix": 2,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 75,
			"st": 15,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 7,
			"ty": 4,
			"nm": "Gender Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"n": [
								"0p833_0p833_0p167_0p167"
							],
							"t": 58,
							"s": [
								20
							],
							"e": [
								100
							]
						},
						{
							"t": 63
						}
					],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						380,
						433.674,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						380,
						433.674,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											5.298,
											0
										],
										[
											0,
											5.298
										],
										[
											-5.677,
											0
										],
										[
											0,
											-5.298
										]
									],
									"o": [
										[
											-5.677,
											0
										],
										[
											0,
											-5.298
										],
										[
											5.677,
											0
										],
										[
											-0.379,
											5.298
										]
									],
									"v": [
										[
											-5.487,
											14.57
										],
										[
											-15.706,
											4.731
										],
										[
											-5.487,
											-5.109
										],
										[
											4.731,
											4.731
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0.377,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-1.135
										],
										[
											-1.136,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											3.406,
											0
										],
										[
											0,
											-7.191
										],
										[
											-7.948,
											0
										],
										[
											0,
											7.191
										],
										[
											1.515,
											2.271
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-1.135,
											0
										],
										[
											0,
											1.135
										],
										[
											0,
											0
										],
										[
											0.379,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0.379
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-1.136,
											0
										],
										[
											0,
											1.135
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-2.649,
											-2.27
										],
										[
											-7.569,
											0
										],
										[
											0,
											7.569
										],
										[
											7.569,
											0
										],
										[
											0,
											-2.649
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											1.135
										],
										[
											1.136,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-0.378
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.378,
											-0.378
										]
									],
									"v": [
										[
											17.221,
											-17.977
										],
										[
											7.759,
											-17.977
										],
										[
											5.867,
											-16.084
										],
										[
											7.759,
											-14.193
										],
										[
											12.678,
											-14.193
										],
										[
											3.596,
											-5.109
										],
										[
											-5.487,
											-8.516
										],
										[
											-19.491,
											4.731
										],
										[
											-5.487,
											17.977
										],
										[
											8.515,
											4.731
										],
										[
											6.244,
											-2.839
										],
										[
											15.706,
											-11.921
										],
										[
											15.706,
											-7.001
										],
										[
											17.598,
											-5.109
										],
										[
											19.491,
											-7.001
										],
										[
											19.113,
											-16.084
										],
										[
											18.734,
											-16.841
										],
										[
											18.734,
											-17.219
										],
										[
											18.355,
											-17.598
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-33.639,
													637.464
												],
												[
													726.361,
													637.464
												],
												[
													726.361,
													-229.885
												],
												[
													-33.639,
													-229.885
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-33.639,
													-229.885
												],
												[
													726.361,
													-229.885
												],
												[
													726.361,
													637.464
												],
												[
													-33.639,
													637.464
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 2",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									33.639,
									229.885
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 7,
					"cix": 2,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											5.298,
											0
										],
										[
											0,
											5.298
										],
										[
											-5.677,
											0
										],
										[
											0,
											-5.298
										]
									],
									"o": [
										[
											-5.677,
											0
										],
										[
											0,
											-5.298
										],
										[
											5.677,
											0
										],
										[
											-0.379,
											5.298
										]
									],
									"v": [
										[
											-5.298,
											14.57
										],
										[
											-15.517,
											4.73
										],
										[
											-5.298,
											-5.11
										],
										[
											4.92,
											4.73
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0.377,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-1.135
										],
										[
											-1.136,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											3.406,
											0
										],
										[
											0,
											-7.191
										],
										[
											-7.948,
											0
										],
										[
											0,
											7.191
										],
										[
											1.515,
											2.271
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-1.135,
											0
										],
										[
											0,
											1.135
										],
										[
											0,
											0
										],
										[
											0.379,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0.379
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-1.136,
											0
										],
										[
											0,
											1.135
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-2.649,
											-2.27
										],
										[
											-7.569,
											0
										],
										[
											0,
											7.569
										],
										[
											7.569,
											0
										],
										[
											0,
											-2.649
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											1.135
										],
										[
											1.136,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-0.378
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.378,
											-0.378
										]
									],
									"v": [
										[
											17.41,
											-17.977
										],
										[
											7.948,
											-17.977
										],
										[
											6.056,
											-16.085
										],
										[
											7.948,
											-14.193
										],
										[
											12.867,
											-14.193
										],
										[
											3.785,
											-5.11
										],
										[
											-5.298,
											-8.516
										],
										[
											-19.302,
											4.73
										],
										[
											-5.298,
											17.976
										],
										[
											8.704,
											4.73
										],
										[
											6.433,
											-2.839
										],
										[
											15.895,
											-11.921
										],
										[
											15.895,
											-7.001
										],
										[
											17.787,
											-5.11
										],
										[
											19.68,
											-7.001
										],
										[
											19.302,
											-16.085
										],
										[
											18.923,
											-16.842
										],
										[
											18.923,
											-17.22
										],
										[
											18.544,
											-17.598
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 2,
							"ty": "sh",
							"ix": 3,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											2.27
										],
										[
											0,
											0
										],
										[
											-2.271,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-2.271
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											2.27,
											0
										]
									],
									"o": [
										[
											-2.271,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-2.271
										],
										[
											0,
											0
										],
										[
											2.272,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											2.27
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-22.329,
											24.79
										],
										[
											-26.492,
											20.626
										],
										[
											-26.492,
											-20.626
										],
										[
											-22.329,
											-24.788
										],
										[
											22.328,
											-24.788
										],
										[
											26.492,
											-20.626
										],
										[
											26.492,
											20.626
										],
										[
											26.113,
											20.626
										],
										[
											21.951,
											24.79
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 3",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 3,
							"ty": "sh",
							"ix": 4,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											4.164,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-4.163
										],
										[
											0,
											0
										],
										[
											-4.163,
											0
										],
										[
											0,
											0
										],
										[
											0,
											4.163
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-4.542,
											0
										],
										[
											0,
											0
										],
										[
											0,
											4.541
										],
										[
											0,
											0
										],
										[
											4.543,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-4.163
										]
									],
									"v": [
										[
											22.328,
											-28.574
										],
										[
											-22.329,
											-28.574
										],
										[
											-30.277,
											-20.626
										],
										[
											-30.277,
											20.626
										],
										[
											-22.329,
											28.574
										],
										[
											22.328,
											28.574
										],
										[
											30.277,
											20.626
										],
										[
											30.277,
											-20.626
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 4",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-33.45,
													637.464
												],
												[
													726.55,
													637.464
												],
												[
													726.55,
													-229.885
												],
												[
													-33.45,
													-229.885
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-33.45,
													-229.885
												],
												[
													726.55,
													-229.885
												],
												[
													726.55,
													637.464
												],
												[
													-33.45,
													637.464
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 6,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									33.45,
									229.885
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 2",
					"np": 8,
					"cix": 2,
					"ix": 2,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											5.298,
											0
										],
										[
											0,
											5.298
										],
										[
											-5.677,
											0
										],
										[
											0,
											-5.298
										]
									],
									"o": [
										[
											-5.677,
											0
										],
										[
											0,
											-5.298
										],
										[
											5.677,
											0
										],
										[
											-0.379,
											5.298
										]
									],
									"v": [
										[
											-5.487,
											14.57
										],
										[
											-15.706,
											4.731
										],
										[
											-5.487,
											-5.109
										],
										[
											4.731,
											4.731
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0.377,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-1.135
										],
										[
											-1.136,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											3.406,
											0
										],
										[
											0,
											-7.191
										],
										[
											-7.948,
											0
										],
										[
											0,
											7.191
										],
										[
											1.515,
											2.271
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-1.135,
											0
										],
										[
											0,
											1.135
										],
										[
											0,
											0
										],
										[
											0.379,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0.379
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-1.136,
											0
										],
										[
											0,
											1.135
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-2.649,
											-2.27
										],
										[
											-7.569,
											0
										],
										[
											0,
											7.569
										],
										[
											7.569,
											0
										],
										[
											0,
											-2.649
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											1.135
										],
										[
											1.136,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-0.378
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.378,
											-0.378
										]
									],
									"v": [
										[
											17.221,
											-17.977
										],
										[
											7.759,
											-17.977
										],
										[
											5.867,
											-16.084
										],
										[
											7.759,
											-14.193
										],
										[
											12.678,
											-14.193
										],
										[
											3.596,
											-5.109
										],
										[
											-5.487,
											-8.516
										],
										[
											-19.491,
											4.731
										],
										[
											-5.487,
											17.977
										],
										[
											8.515,
											4.731
										],
										[
											6.244,
											-2.839
										],
										[
											15.706,
											-11.921
										],
										[
											15.706,
											-7.001
										],
										[
											17.598,
											-5.109
										],
										[
											19.491,
											-7.001
										],
										[
											19.113,
											-16.084
										],
										[
											18.734,
											-16.841
										],
										[
											18.734,
											-17.219
										],
										[
											18.355,
											-17.598
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-33.639,
													637.464
												],
												[
													726.361,
													637.464
												],
												[
													726.361,
													-229.885
												],
												[
													-33.639,
													-229.885
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-33.639,
													-229.885
												],
												[
													726.361,
													-229.885
												],
												[
													726.361,
													637.464
												],
												[
													-33.639,
													637.464
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 2",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.275,
									0.289999988032,
									0.375999989229,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									33.639,
									229.885
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 3",
					"np": 7,
					"cix": 2,
					"ix": 3,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 75,
			"st": 15,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 8,
			"ty": 2,
			"nm": "Layer 2",
			"refId": "image_0",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						380,
						433.674,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						380,
						433.674,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"ip": 0,
			"op": 75,
			"st": 15,
			"bm": 0
		}
	],
	"markers": []
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/healthcare/animations/unify/data.json
// module id = 1393
// module chunks = 0